import {
  BackendServerActionType,
  ButtonElementModel,
  CastUtility,
  DbCommonColumnName,
  DevelopDialogScript,
  DevelopScriptServicePack,
  GocooEngineConfig,
  InputPartsBaseModel,
  LabelAndValue,
  LinkElementModel,
  ListPanelElementModel,
  PanelModel,
  PanelType,
  PartsBaseModel,
  ResponseDataModel,
  ValidateCheckUtility,
} from '@ktvs8/gocoo-engine-front-end';
import { ApplicationUserUtility, UserRole } from 'src/app/utility/application-user-utility';
/**
 * 番組名選択ダイアログのスクリプト
 */
export class MProgramDialogConditionList implements DevelopDialogScript {
  readonly scriptName: string = 'MProgramDialogConditionList';

  constructor() {}

  /**
   * 検索が完了したかどうか
   */
  isFinishedSearch: boolean = true;

  /**
   * ダイアログが表示された際の初期処理
   * @param panelModels
   * @param service
   * @param receivedData
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack, receivedData: any): void {
    const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
    //プロデューサーのメールアドレスから名前を表示するリレーショナルに置き換える
    ApplicationUserUtility.fetchProducerList().then((producerList) => {
      const producerMapList: LabelAndValue[] = [];
      producerList.forEach((producer) => {
        const producerMap: LabelAndValue = {
          label: producer['UserName'],
          value: producer['Email'],
        };
        producerMapList.push(producerMap);
      });
      listPanel.listElementModel.headerModel.headers.forEach((header) => {
        if (header.columnName !== 'Producer') {
          return;
        }
        header.relationalListKeys = ['Producer'];
        header.relationalListMap = {
          Producer: producerMapList,
        };
      });

      this.search('', panelModels, service);
      this.isFinishedSearch = true;
    });
  }

  /**
   * ダイアログで何らかのボタンが押下された際の処理
   * @param panelModels パネルモデルのマップ
   * @param clickedButtonElement 押下されたボタンのモデル
   * @param service サービス
   * @returns
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ) {}

  /**
   * 独自のバリデーションチェック
   * @param panelModels
   * @returns
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
  /**
   * input-partsのイベント
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ) {
    if (inputPartsModel.id === 'FreeWords' && inputPartsModel.lastEvent?.type === 'change') {
      this.search(inputPartsModel.value, panelModels, service);
    }
  }

  /**
   * リンクが押下されたときの処理
   * @param panelModels パネルモデルのマップ
   * @param clickedLinkElement 押下されたリンクモデル
   * @param service スクリプトのサービス
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ) {
    if (clickedLinkElement.id.includes('ProgramName')) {
      const result = this.getSelectedData(panelModels, clickedLinkElement);
      service.dialogService.closeViewDialog(result);
      return;
    }
  }

  returnParent(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ) {
    console.log('returnParent');
  }
  /**
   * 選択されたチケットキーを取得する
   * @param panelModels
   * @param clickedLinkElement
   * @returns
   */
  getSelectedData(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel
  ): MProgramSelectedResult {
    const index = this.getIndex(clickedLinkElement);
    const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
    const row = listPanel.listElementModel.bodyModel.rows[index];
    const programName = row.getCell('ProgramName');
    const isSpotProgram = row.getCell('IsSpotProgram');

    if (programName === undefined) {
      throw new Error('ProgramName is undefined');
    }
    if (isSpotProgram === undefined) {
      throw new Error('IsSpotProgram is undefined');
    }

    return <MProgramSelectedResult>{
      ticketKey: row.commonDBValue.ticketKey,
      programName: programName.cellModel.value,
      isSpotProgram: isSpotProgram.cellModel.value,
    };
  }

  /**
   * 検索処理を実行する
   * @param freeWords 画面で入力された番組名
   * @param panelModels
   * @param service
   */
  search(freeWords: string, panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack) {
    if (!this.isFinishedSearch) {
      return;
    }

    this.isFinishedSearch = false;
    /**
     * 検索条件を作成
     *
     * @returns
     * FreeWords : 番組名（部分一致）
     * FilterUserEmailAddress : 自身をプロデューサーに含む　（権限制御）
     *
     */
    const createCondition = (): { [key: string]: string } => {
      const condition: { [key: string]: string } = {};
      condition['FreeWords'] = freeWords;

      const userRole = GocooEngineConfig.loginUser.userRole;
      const userEMail = GocooEngineConfig.loginUser.mailAddress;

      // 権限　一般の方は自身がプロデューサーの番組のみ
      if (userRole === UserRole.Production) {
        condition['FilterUserEmailAddress'] = userEMail;
      }
      return condition;
    };

    try {
      const callback = (responseData: ResponseDataModel) => {
        this.setSpotProgramStyle(listPanel);
        this.setProducerName(listPanel);
        this.isFinishedSearch = true;
      };
      const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
      listPanel.fetchList('MProgram', createCondition(), callback);
    } catch (e) {
      this.isFinishedSearch = true;
    }
  }

  /**
   * プロデューサーの名前をセットする
   * @param listPanel
   */
  setProducerName(listPanel: ListPanelElementModel): void {
    listPanel.listElementModel.bodyModel.refreshRelationalColumnsValue(listPanel.listElementModel.headerModel.headers);
  }

  /**
   * 事前番組のスタイルをセットする
   * @param listPanel
   */
  setSpotProgramStyle(listPanel: ListPanelElementModel): void {
    listPanel.listElementModel.bodyModel.rows.forEach((row) => {
      var spotCell = row.getCell('IsSpotProgram');
      var programCell = row.getCell('ProgramName');
      if (spotCell !== undefined && programCell !== undefined) {
        if (spotCell.cellModel.value === true) {
          programCell.cellModel.class.push('spot-program');
        }
      }
    });
  }

  /**
   * 取得した番組一覧をフィルタリングする
   * @param responseData
   * @param messageService
   * @returns
   */
  filterProgram(responseData: ResponseDataModel): ResponseDataModel {
    const userRole = GocooEngineConfig.loginUser.userRole;
    const userEMail = GocooEngineConfig.loginUser.mailAddress;

    if (
      ValidateCheckUtility.isEmpty(responseData.data) ||
      (responseData.data.DataList == null && responseData.data.DataList.length == 0)
    ) {
      return responseData;
    }

    // 表示する番組をフィルタリングする
    responseData.data.DataList = (responseData.data.DataList as any[]).filter((data) => {
      // 権限　一般以外
      if (userRole !== UserRole.Production) {
        return true;
      }

      // プロデューサーが未指定
      if (ValidateCheckUtility.isEmpty(data['Producer'])) {
        if (ValidateCheckUtility.isEmpty(data[DbCommonColumnName.HISTORY])) {
          return false;
        }
        // 自身が作成した番組のみ
        return userEMail === data[DbCommonColumnName.HISTORY][DbCommonColumnName.CREATE_USER_ID];
      }

      // 自信をプロデューサーに含む
      return (data['Producer'] as any[]).includes(userEMail);
    });
    return responseData;
  }
  /**
   * 行数を取得する
   * @param element
   * @returns
   */
  getIndex(element: PartsBaseModel): number {
    return CastUtility.anyToNumber(element.id.split('_')[1]);
  }
}

/**
 * ダイアログの選択結果
 *
 * 親に返却するデータの型を定義する
 */
export interface MProgramSelectedResult {
  ticketKey: string;
  programName: string;
  isSpotProgram: boolean;
}
